(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.componentSearchResults = {
    searchBoxLabel: function () {
      var $searchBox = $('#block-searchresults input.gsc-input');
      var searchBoxId = $searchBox.attr('id');
      $searchBox.attr('placeholder', 'Search');
      $searchBox.before('<label for="' + searchBoxId + '" class="form-label-top">Search</label>');
    },
    attach: function (context, settings) {
      // Add search placeholder and label.
      if ($('#block-searchresults .gsc-input-box').length > 0) {
        Drupal.behaviors.componentSearchResults.searchBoxLabel();
      }
      else {
        setTimeout(Drupal.behaviors.componentSearchResults.searchBoxLabel, 1000);
      }
    }
  };
})(jQuery, Drupal);
